import { orderBy } from 'firebase/firestore';
import type { Flow } from '@flintmint/core-shared/firestore/schemas';

import { createFirestoreCrudService } from './firestore-crud-service';

export const FLOWS_COLLECTION_NAME = 'flows';

export interface FlowWithId extends Flow {
  id: string;
}

export type FlowInput = Omit<Flow, 'createdAt' | 'updatedAt' | 'updatedBy'>;

const flowsService = createFirestoreCrudService<Flow, FlowInput>({
  collectionName: FLOWS_COLLECTION_NAME,
  entityName: 'Flow',
  subscribeName: 'subscribeToFlows',
});

export const createFlow = flowsService.create;

export const updateFlow = flowsService.update;

export const deleteFlow = flowsService.remove;

export function subscribeToFlows(onData: (flows: FlowWithId[]) => void, onError: (error: Error) => void): () => void {
  return flowsService.subscribe([orderBy('name')], onData, onError);
}
